var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('Navigation'),_c('div',{staticStyle:{"height":"2000px"}},[_vm._v("666666")]),_c('bottom')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }